// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9921bb10","453":"df4389a9","634":"46c91bb5"}[chunkId] + ".chunk.js";
};